import classNames from "classnames";
import s from "./TFoot.module.scss";

type Props = {
  className?: string;
};

const TFoot: React.FC<Props> = ({ children, className }) => (
  <tfoot className={classNames(s.sticky, className)}>
    {children}
  </tfoot>
);

export default TFoot;
